import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'sc-export-button',
  templateUrl: './export-button.component.html',
  styleUrls: ['./export-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ExportButtonComponent implements OnInit {
  @Input() cssClass: string = '';
  @Input() tooltip: string = '';
  @Input() text: string = '';
  @Input() loading: boolean = false;
  @Input() exlude: string;
  @Input() show: string;
  @Input() disabled: boolean = false;
  @Output() export: EventEmitter<any> = new EventEmitter();
  onlyOne: boolean = false;

  exludeType: any = {
    csv: false,
    pdf: false,
    xls: false,
    json: false,
    xml: false,
    png: false,
    svg: false
  };
  extraButtons: string[] = [];

  constructor(private translate: TranslateService) {
    this.tooltip = this.translate.instant('EXPORT');
  }

  ngOnInit() {
    if (this.exlude) {
      let excludeArr = this.exlude.split(',');
      for (let exclude of excludeArr) {
        this.exludeType[exclude.trim()] = true;
      }
    }

    if (this.show) {
      //Show will override exclude
      //Hiding all elements to only show the ones in this.show
      for (let i in this.exludeType) this.exludeType[i] = true;

      let showArr = this.show.split(',');

      if (showArr.length === 1) {
        this.onlyOne = true;
      } else {
        this.onlyOne = false;
      }

      for (let show of showArr) {
        show = show.trim();

        if (!this.exludeType.hasOwnProperty(show)) {
          this.extraButtons.push(show);
        }
        this.exludeType[show] = false;
      }
    }
  }

  doExport(type: string) {
    type = type.toUpperCase().trim();
    this.export.emit(type);
  }
}
